import DOMPurify from 'dompurify';

const FONT_SIZE_BY_LABEL = {
    small: '2',
    normal: '3',
    large: '5',
};

const ALLOWED_FONT_SIZES = new Set(['1', '2', '3', '4', '5', '6', '7']);

const PRODUCT_DESCRIPTION_SANITIZE_CONFIG = {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'b', 'ul', 'ol', 'li', 'font'],
    ALLOWED_ATTR: ['size'],
    ALLOW_ARIA_ATTR: false,
    ALLOW_DATA_ATTR: false,
};

if (typeof DOMPurify.addHook === 'function') {
    DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
        if (node.nodeName.toLowerCase() !== 'font' || data.attrName !== 'size') {
            return;
        }

        if (!ALLOWED_FONT_SIZES.has(data.attrValue)) {
            data.attrValue = '3';
        }
    });
}

function escapeHtml(value) {
    return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

function applyInlineTextFormat(text) {
    let nextText = escapeHtml(text);

    nextText = nextText.replace(/\[size=(small|normal|large)\]([\s\S]*?)\[\/size\]/gi, (_, size, content) => (
        `<font size="${FONT_SIZE_BY_LABEL[size.toLowerCase()] || FONT_SIZE_BY_LABEL.normal}">${content}</font>`
    ));

    return nextText.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
}

function plainTextToDescriptionHtml(value) {
    const lines = String(value || '').split(/\r?\n/);
    const blocks = [];
    let listItems = [];

    const flushList = () => {
        if (listItems.length === 0) {
            return;
        }

        blocks.push(`<ul>${listItems.map((item) => `<li>${applyInlineTextFormat(item)}</li>`).join('')}</ul>`);
        listItems = [];
    };

    lines.forEach((line) => {
        const bulletMatch = line.match(/^\s*\*\s+(.+)$/);

        if (bulletMatch) {
            listItems.push(bulletMatch[1]);
            return;
        }

        flushList();

        if (line.trim() === '') {
            blocks.push('<p><br></p>');
            return;
        }

        blocks.push(`<p>${applyInlineTextFormat(line)}</p>`);
    });

    flushList();

    return blocks.join('');
}

export function sanitizeProductDescriptionHtml(value) {
    const rawValue = String(value || '');
    const source = /<\/?[a-z][\s\S]*>/i.test(rawValue)
        ? rawValue
        : plainTextToDescriptionHtml(rawValue);

    return DOMPurify.sanitize(source, PRODUCT_DESCRIPTION_SANITIZE_CONFIG);
}
